const EventBus = window.EventBus;

export const Dealertrack = {
  template: `
  <div class="w-full mt-2 align-center">
  <div class="container mx-auto">
  <div class="lowest-payment-widtget">
  <div :data-dtc-paymentDriverWidget="'prtnr='+dtprtnr+'&pdid='+pdid+'&zip='+zip+'&vin='+vehicle.vin+'&msrp='+vehicle.saleprice+'&cp='+vehicle.price+'&cond='+(vehicle.condition == 'New' ? 'N' : 'U')+'&yr='+vehicle.year+'&mk='+vehicle.make+'&model='+vehicle.model+'&jrr='+jrr+'&hash='+getHash()+'&trim='+(vehicle.trim && vehicle.trim.length ? vehicle.trim : '')+'&kms='+(vehicle.mileage && vehicle.mileage.length ? vehicle.mileage : '')+'&pkg='+(vehicle.packages && vehicle.packages.length ? vehicle.packages : '')+'&disp=&opt=&trans='+(vehicle.transmission && vehicle.transmission.length ? vehicle.transmission : '')+'&drv='+(vehicle.drivetrain && vehicle.drivetrain.length ? vehicle.drivetrain : '')+''"></div>
  </div>
  </div>
  <!-- DealerTrack Canada Payment Driver -->
<script type="application/javascript">
    (function (d, s, id) {
      if (d.getElementById(id)) {
        d.getElementById(id).remove();
    }
        var js, fjs = d.getElementsByTagName(s)[0];
        js = d.createElement(s); js.id = id;
        js.src = 'https://paymentdriver.dealertrack.ca/js/dtc-paymentDriver-widget.js';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'dtc-pd-widget'));
</script>
<!-- End DealerTrack Canada Payment Driver -->

</div>
  `,
  data: function () {
    return {
      dtprtnr: this.prtnr,
    }
  },
  mounted: function(){
    let criptoScript = document.createElement('script');
    criptoScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js')
    document.head.appendChild(criptoScript);
  },
  props: [
    'prtnr',
    'pdid',
    'zip',
    'zipcode',
    'jrr',
    'secret',
    'vehicle'
  ],
  created(){
  },
  methods: {
    getHash(){
      var input = this.prtnr + this.pdid + this.zipcode + this.vehicle.vin.toUpperCase() +  (this.condition == "New" ? 'N' : (this.vehicle.demo ? 'N' : 'U')) + this.vehicle.price + this.vehicle.saleprice;
      var key = CryptoJS.enc.Utf8.parse(this.secret);
      var hmac = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(input, key))

      return hmac;
    }
  }
}